var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('div',[_vm._v(_vm._s(("{" + _vm.component + "}")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }